export const BOOKING_TAB = {
  BULK: 'BULK',
  SINGLE: 'SINGLE',
};

export const ADDRESS_ENTITY_SUFFIX = 'Entity';

export const DOODLE_VALUE = 'doodle-value';

export const STORAGE = {
  SINGLE_BOOKING: '__SINGLE__',
  BULK_BOOKING: '__BULK__',
  SAMEDAY_ONBOARDING: '__SAME_DAY__',
  SINGLE_BOOKING_SENDER_INFO: '__SENDER_SINGLE__',
  BULK_BOOKING_SENDER_INFO: '__BULK_SENDER_SINGLE__',
  EXCEL_NEW_TEMPLATE: '_EXCEL_NEW_TEMPLATE_',
  MSD_EXCEL_NEW_TEMPLATE: '_MSD_EXCEL_NEW_TEMPLATE_',
};

// Deprecated in V2, in which this is fetched from config
export const COD_SERVICE_TYPE_STG = {
  4849: 'PH',
  5304: 'ID',
  5907: 'VN',
  3734: 'VN',
  25793: 'ID',
  27516: 'MY',
};

// Deprecated in V2, in which this is fetched from config
export const COD_SERVICE_TYPE_PROD = {
  9231: 'VN',
  9638: 'VN',
  3537: 'VN',
  7144: 'VN',
  9443: 'VN',
  9350: 'VN',
  3282: 'VN',
  9290: 'VN',
  2846: 'VN',
  7203: 'VN',
  9690: 'VN',
  7183: 'VN',
  9549: 'VN',
  3312: 'VN',
  2593: 'VN',
  8124: 'VN',
  5918: 'VN',
  7184: 'VN',
  4570: 'VN',
  5778: 'VN',
  5775: 'VN',
  1002: 'VN',
  5841: 'VN',
  9881: 'VN',
  11517: 'VN',
  11518: 'VN',
  11519: 'VN',
  12047: 'VN',
  12002: 'VN',
  12003: 'VN',
  5079: 'PH',
  2027: 'PH',
  2936: 'PH',
  4484: 'PH',
  3425: 'ID',
  6581: 'ID',
  2374: 'ID',
  2576: 'ID',
  9946: 'ID',
  6861: 'ID',
  10870: 'ID',
  10871: 'ID',
  11008: 'ID',
  11009: 'ID',
  4154: 'TH',
  8741: 'PH',
  1820: 'PH',
  2367: 'PH',
  7143: 'PH',
  10323: 'PH',
  1696: 'PH',
  6047: 'PH',
  9402: 'PH',
  1768: 'PH',
  2929: 'PH',
  7729: 'PH',
  9039: 'PH',
  9345: 'PH',
  2284: 'PH',
  4314: 'PH',
  1330: 'PH',
  1905: 'PH',
  6418: 'PH',
  8022: 'PH',
  9227: 'PH',
  1197: 'PH',
  2433: 'PH',
  4396: 'PH',
  5741: 'PH',
  8575: 'PH',
  2642: 'PH',
  3079: 'PH',
  257: 'PH',
  11894: 'KH',
  11895: 'KH',
  12048: 'VN',
};

export const UNUSED_COD_FIELD_COMPANIES = {
  1000032576: 'Saigon coop',
};

export const COUNTRY_MAP = {
  ID: 'Indonesia',
  KH: 'Cambodia',
  MM: 'Myanmar',
  MY: 'Malaysia',
  PH: 'Philippines',
  SG: 'Singapore',
  TH: 'Thailand',
  VN: 'Vietnam',
};

export const VIETNAM_COUNTRY_MAP = {
  Vietnam: 'VN',
  'Việt Nam': 'VN',
  'Viet Nam': 'VN',
};

export const PHILIPPINES_COUNTRY_MAP = {
  Pilipinas: 'PH',
  Philippines: 'PH',
};

// Payment types
export const CASH = 'CASH';
export const CASH_BY_SENDER = 'SENDER';
export const CASH_BY_RECIPIENT = 'RECIPIENT';
export const CARD = 'CARD';
export const ADD_CASHLESS_ON_APP = 'ADD_CASHLESS_ON_APP';
export const ADD_CASHLESS_ON_GFB_PORTAL = 'ADD_CASHLESS_ON_GFB_PORTAL';
export const POSTPAID_BILLING_TYPE = 'postpaidBilling';
export const PAYMENT_TYPE_OVO = 'OVO Points';
export const PAYMENT_TYPE_GRABPAY = 'GrabPay Credits';
export const PAYMENT_TYPE_INSTALMENT = 'Instalment';
export const PAYMENT_TYPE_PAYLATER = 'PayLater';

export const WEB_UNSUPPORTED_PAYMENT_TYPES = [
  PAYMENT_TYPE_OVO,
  PAYMENT_TYPE_INSTALMENT,
  PAYMENT_TYPE_PAYLATER,
];

export const FIELD_NAME = {
  SENDER_NAME: 'senderName',
  SENDER_PHONE: 'senderPhone',
  SENDER_ADDRESS: 'senderAddress',
  SENDER_ADDRESS_DETAIL: 'senderAddressDetail',
  SENDER_MAP: 'senderMap',
  RECIPIENT_NAME: 'recipientName',
  RECIPIENT_PHONE: 'recipientPhone',
  RECIPIENT_ADDRESS: 'recipientAddress',
  RECIPIENT_ADDRESS_DETAIL: 'recipientAddressDetail',
  RECIPIENT_MAP: 'recipientMap',
  SERVICE_TYPE: 'serviceType',
  ITEM_AMOUNT: 'itemAmount',
  PROMO: 'promo',
  PAYMENT_METHOD: 'paymentMethod',
  PARTNER_ORDER_ID: 'partnerOrderID',
};

export const REQUIRED_FIELDS = [
  FIELD_NAME.SENDER_NAME,
  FIELD_NAME.SENDER_PHONE,
  FIELD_NAME.SENDER_ADDRESS,
  FIELD_NAME.RECIPIENT_NAME,
  FIELD_NAME.RECIPIENT_PHONE,
  FIELD_NAME.RECIPIENT_ADDRESS,
];

export const VALIDATE_MESSAGE = {
  ITEM_AMOUNT: 'booking.validateMessage.itemAmount',
  REQUIRED_NAME: 'booking.validateMessage.name.required',
  REQUIRED_SENDER_NAME: 'booking.validateMessage.senderName.required',
  REQUIRED_RECEIVER_NAME: 'booking.validateMessage.receiverName.required',
  INVALID_NAME: 'booking.validateMessage.name.invalid',
  MAX_LENGTH_NAME: 'booking.validateMessage.name.maxLength',
  MIN_LENGTH_NAME: 'booking.validateMessage.name.minLength',
  PHONE_SENDER_INVALID: 'booking.validateMessage.phoneSender.invalid',
  PHONE_RECEIVER_INVALID: 'booking.validateMessage.phoneReceiver.invalid',
  PHONE_MIN_LENGTH: 'booking.validateMessage.phone.minLength',
  PHONE_MAX_LENGTH: 'booking.validateMessage.phone.maxLength',
  PAYMENT_NOT_FOUND: 'booking.validateMessage.paymentNotFound',
  LOCATION_NOT_FOUND: 'booking.validateMessage.locationNotFound',
  INVALID_PROMO: 'booking.validateMessage.invalidPromo',
  ITEM_AMOUNT_REGEX: 'booking.validateMessage.itemAmountRegex',
  COD_INVALID_AMOUNT: 'booking.validateMessage.COD.invalidAmount',
  COD_MIN_AMOUNT: 'booking.validateMessage.COD.minAmount',
  COD_MAX_AMOUNT: 'booking.validateMessage.COD.maxAmount',
};

export const FIELD_LABEL = {
  LOCATION_DETAILS: 'booking.fieldLabel.locationDetails',
  PAYMENT_METHOD: 'booking.fieldLabel.paymentMethod',
  PROMO: 'booking.fieldLabel.promo',
  RECIPIENT_ADDRESS: 'booking.fieldLabel.recipientAddress',
  RECIPIENT_MOBILE_NUMBER: 'booking.fieldLabel.recipientMobileNumber',
  RECIPIENT_NAME: 'booking.fieldLabel.recipientName',
  SENDER_NAME: 'booking.fieldLabel.senderName',
  SENDER_MOBILE_NUMBER: 'booking.fieldLabel.senderMobileNumber',
  SENDER_ADDRESS: 'booking.fieldLabel.senderAddress',
  ITEM_AMOUNT: 'booking.fieldLabel.itemAmount',
  SERVICE_TYPE: 'booking.fieldLabel.serviceType',
  PARTNER_ORDER_ID: 'booking.fieldLabel.deliveryInstruction',
};

export const FIELD_PLACEHOLDER = {
  ADDRESS: 'booking.fieldPlaceholder.address',
  LOCATION_DETAILS: 'booking.fieldPlaceholder.locationDetails',
  MOBILE_NUMBER: 'booking.fieldPlaceholder.mobileNumber',
  PROMO: 'booking.fieldPlaceholder.promo',
  RECIPIENT_NAME: 'booking.fieldPlaceholder.recipientName',
  SENDER_NAME: 'booking.fieldPlaceholder.senderName',
  ITEM_AMOUNT: 'booking.fieldPlaceholder.itemAmount',
  CASH_BY_SENDER: 'booking.paymentMethod.cashBySender',
  CASH_BY_RECIPIENT: 'booking.paymentMethod.cashByRecipient',
  PARTNER_ORDER_ID: 'booking.fieldPlaceholder.deliveryInstruction',
  CASH: 'booking.paymentMethod.cash',
  CORP_BILLING: 'booking.paymentMethod.corpBilling',
  GRAB_PAY: 'booking.paymentMethod.grabPay',
};

// Map payment ID to human readable display name ID
export const PAYMENT_DISPLAY_NAMES = {
  [CASH_BY_SENDER]: FIELD_PLACEHOLDER.CASH_BY_SENDER,
  [CASH_BY_RECIPIENT]: FIELD_PLACEHOLDER.CASH_BY_RECIPIENT,
  [CASH]: FIELD_PLACEHOLDER.CASH,
  [POSTPAID_BILLING_TYPE]: FIELD_PLACEHOLDER.CORP_BILLING,
};

export const TAB_LABEL = {
  SINGLE_BOOKING: 'booking.tabLabel.singleBooking',
  BULK_BOOKING: 'booking.tabLabel.bulkBooking',
};

export const UPLOAD_FILE = {
  BUTTON: 'booking.uploadFile.button',
  DOWNLOAD_TEMPLATE: 'booking.uploadFile.downloadTemplate',
  INSTRUCTION: 'booking.uploadFile.instruction',
  SUB_INSTRUCTION: 'booking.uploadFile.subInstruction',
  SUB_INSTRUCTION_MANUAL: 'booking.uploadFile.subInstructionManual',
};

export const REMOVE_DELIVERY = {
  BUTTON: 'booking.removeDelivery.button',
  CANCEL_TEXT: 'booking.removeDelivery.cancelText',
  CONTENT: 'booking.removeDelivery.content',
  OK_TEXT: 'booking.removeDelivery.okText',
  TITLE: 'booking.removeDelivery.title',
};

export const REVIEW = {
  MANUAL_ERROR_NOTE: 'booking.review.manualErrorNote',
  NOT_READY_YET: 'booking.review.notReadyYet',
  READY_TO_GO: 'booking.review.readyToGo',
  READY_TO_GO_UPPER_CASE: 'booking.review.readyToGoUpperCase',
  REVIEW: 'booking.review.review',
  UPLOAD_ERROR_NOTE: 'booking.review.uploadErrorNote',
};

export const NON_DISTANCE_MODAL = {
  CANCEL_TEXT: 'booking.nonDistanceModal.cancelText',
  OK_TEXT: 'booking.nonDistanceModal.okText',
  SUB_TITLE: 'booking.nonDistanceModal.subTitle',
  TITLE: 'booking.nonDistanceModal.title',
};

export const BULK_BOOKING = {
  SUBMIT_BUTTON: 'booking.bulkBooking.submitButton',
  SUBMIT_BUTTON_PLURAL: 'booking.bulkBooking.submitButtonPlural',
  SAVE: 'booking.bulkBooking.save',
};
export const SERVICE_TYPE = {
  INSTANT: 0,
  SAMEDAY: 1,
};
export const COUNTRY_ESTIMATED_TIME = {
  ID: 90,
  VN: 60,
  PH: 30,
  MY: 60,
};
export const ABOUT_SENDER = 'booking.aboutSender';
export const ABOUT_RECIPIENT = 'booking.aboutRecipient';
export const MAP_NOTE = 'booking.mapNote';
export const BOOK = 'booking.book';
export const TOTAL_PRICE = 'booking.totalPrice';
export const SERVICE_TYPE_DISABLE = 'booking.serviceTypeDisable';
export const SERVICE_TYPE_SUB_INFO = 'booking.defaultServiceTypeSubInfo';
export const SAME_DAY_NOT_AVAILABLE = 'booking.sameDayAvailability';
export const ADD_ANOTHER_DELIVERY = 'booking.addAnotherDelivery';
export const DELIVERY = 'booking.delivery';
export const DELIVERIES = 'booking.deliveries';
export const MAXIMUM_DELIVERY_NOTE = 'booking.maximumDeliveryNote';
export const REVIEW_DELIVERY = 'booking.bulkBooking.review';
export const SAVE_ADDRESS = 'booking.common.save';

export const BULK_PAGE_MODELS = {
  DOWNLOAD: 'DOWNLOAD',
  UPLOAD: 'UPLOAD',
  MSD_ONBOARDING: 'MSD',
};

export const BULK_UPLOAD_PARSING_ERRORS = {
  failed: 'failed',
  languageError: 'languageError',
  deprecatedTemplate: 'deprecatedTemplate',
};

export const MAX_DROPOFF_LOCATIONS = 6;
export const MAX_ORDERS_PER_BATCH = 30;

export const SERVICE_TYPE_FIELDS = [
  'grabexpress.service.ExpressServiceID',
  'paxapp.ui.IconLink',
  'grabexpress.service.MultiStopMaxStopCount',
  'grabexpress.service.CashOnDelivery',
  'grabexpress.service.MaxWeight',
  'web.data.HTML',
];

export const PAX_USER_PROFILE_ID = 'personal';
export const PAX_USER_GROUP_ID = 'personalGroup';
export const PAX_USER_PROFILE_NAME = 'appBar.personal';
export const PAX_USER_GROUP_NAME = 'appBar.personal';

export const PAX_USER_PROFILE = {
  id: PAX_USER_PROFILE_ID,
  name: PAX_USER_PROFILE_NAME,
  groups: [
    {
      id: PAX_USER_GROUP_ID,
      name: PAX_USER_GROUP_NAME,
    },
  ],
};

// https://gitlab.myteksi.net/gophers/go/-/blob/master/express/grab-express/dto/geerrors/geerrors_pax.go
// Maps error code from BE getQuote response into error message keys
// TODO: Support more error codes
export const QUOTE_ERRORS_MAP = {
  1000: 'v2.error.quote.getQuoteFailedError.description.exceedDistanceLimit',
  1010: 'v2.error.quote.getQuoteFailedError.description.errorMultipleCity',
  1014: 'v2.error.quote.getQuoteFailedError.description.exceedSameDayTimeWindow',
  1168: null, // Soft block - uses BE message
  1169: null, // Hard block - uses BE message
};

// EV Regulation error codes
export const EV_REGULATION_ERROR_CODE = {
  SOFT_BLOCK: 1168, // Soft block - uses BE message
  HARD_BLOCK: 1169, // Hard block - uses BE message
};

// Soft block error codes that don't prevent booking
export const SOFT_BLOCK_ERROR_CODES = [EV_REGULATION_ERROR_CODE.SOFT_BLOCK];

export const QUOTE_OPTIMIZED_FAILED = 'QUOTE_OPTIMIZED_FAILED';
export const QUOTE_OPTIMIZED_ALLOW_REVERT = 'QUOTE_OPTIMIZED_ALLOW_REVERT';
export const QUOTE_OPTIMIZED = 'QUOTE_OPTIMIZED';

export const BookingMode = {
  Single: 'single',
  Multi: 'multi',
  Bulk: 'bulk',
};

export const FILTER_FIELD = {
  KEYWORDS: 'KEYWORDS',
  DATE_RANGE: 'DATE_RANGE',
};

export const ExpressServiceIDs = {
  Instant: 0,
  SameDay: 1,
};

export const DEFAULT_MAX_SAVED_POIS_DISPLAY = 10;
